import React from "react";
import { injectIntl } from "react-intl";
import Breadcrumb from "../../common/Breadcrumb";
import ButtonBack from "../../common/ButtonBack";
import Propertii from "../../common/Propertii";
import TenantReport from "../../common/ReportTenants";

class Tenants extends Propertii {

    /**
     * Render the component.
     *
     * @returns {*} - The company tenant report component.
     */
    render() {

        return(
            <div className="content-block">

                <div className="container">

                    <Breadcrumb parentPath="/manager/reports" parentPage="Reports" childPage="Tenants" />

                    <TenantReport companyId={this.props.userSession.sessionRole.companyId} />

                    <div className="row">
                        <div className="col text-right">
                            <ButtonBack path="/manager/reports" />
                        </div>
                    </div>

                </div>

            </div>
        )
    };
}

export default injectIntl(Tenants);